import React, { useEffect, useState } from "react";
import { useQuery, gql } from "@apollo/client";
import { useParams } from "react-router-dom";
import { GET_INTEGRATION } from "../../graphql/querys";
import {
  Button,
  Card,
  CardContent,
  CardMedia,
  CircularProgress,
  Divider,
  Typography,
  styled,
} from "@mui/material";
import { details } from "../../util/integration";
const Next2 = styled((props) => <Button variant="contained" {...props} />)({
  color: "white",
  borderRadius: "30px",
  height: "45px",
  background: "#d9bca9",
  boxShadow: "none",
});
const Integration = (props) => {
  const { integration } = useParams();
  const { loading, error, data } = useQuery(GET_INTEGRATION, {
    variables: { integration: integration.replace(/_/g, " ") },
  });

  if (loading) return <div style={{width:'100%',height:'600px'}} className="flex align justify"><CircularProgress size={80}/></div>;
  if (error) return <p>Error</p>;

  return (
    <Card
      style={{
        maxWidth: "1000px",
        margin: "30px auto",
        gap: "20px",
        padding: "50px 0",
      }}
      className="flex justify align column"
    >
      <img
        component="img"
        alt={data.getIntegration.name}
        style={{ width: "300px" }}
        src={data.getIntegration.logo}
        title={data.getIntegration.name}
      />
      <Typography gutterBottom variant="h5" component="div">
        {data.getIntegration.name}
      </Typography>
      <div className="flex" style={{ width: "100%" }}>
        <div
          className="flex align column"
          style={{ gap: "10px" }}
        >
          <Typography variant="h5">Features</Typography>{" "}
          <ul style={{maxWidth:'350px',gap:'10px'}} className="flex column">
            {details
              .find((val) => val.name == integration)
              .features.map((val) => (
                <li>{val}</li>
              ))}
          </ul>
        </div>
        <Divider orientation="vertical" style={{ height: "300px" }} />
        <div
          className="flex align column"
          style={{ gap: "10px"}}
        >
          {" "}
          <Typography variant="h5">Requirements</Typography>
          <ul style={{maxWidth:'350px',gap:'10px'}} className="flex column">
            {details
              .find((val) => val.name == integration)
              .requirements.map((val) => (
                <li>{val}</li>
              ))}
          </ul>
        </div>
      </div>
      <Next2 style={{ padding: "20px" }} disabled> Connect {integration}</Next2>
    </Card>
  );
};

export default Integration;
